import {action, observable, runInAction, makeObservable} from 'mobx';
// import Purchases, {LOG_LEVEL} from 'react-native-purchases'
import {decorate, inject, injectable} from '@yosmanyga/di';
import {CredentialManager, CredentialType, Dispatcher} from '@yosmanyga/base';

// const REVENUECAT_API_KEY = 'goog_grdEuugFCKQcPfgezpmseMRykBk';

// TODO: This class is not used
class AppCredentialController {
    loaded: boolean;
    assigningAsGuest: boolean;
    assigningWithFacebook: boolean;
    credential: CredentialType | null;

    constructor(
        private dispatcher: Dispatcher,
        private credentialManager: CredentialManager,
    ) {
        this.loaded = false;
        this.assigningAsGuest = false;
        this.assigningWithFacebook = false;
        this.credential = null;



        makeObservable(this, {
            loaded: observable,
            assigningAsGuest: observable,
            assigningWithFacebook: observable,
            credential: observable,
            load: action,
            // assignAsGuest: action,
            // assignWithFacebook: action,
            delete: action,
            // listenToCredentialSaved: action
        });
    }

    load = async () => {
        await this.credentialManager.load();

        const credential = this.credentialManager.get();

        // Purchases.configure({
        //     apiKey: REVENUECAT_API_KEY,
        //     appUserID: credential.id
        // });
        // await Purchases.setLogLevel(LOG_LEVEL.VERBOSE)

        // try {
        //     const customerInfo = await Purchases.getCustomerInfo();
        // } catch (e) {
        //     // Error fetching customer info
        // }

        runInAction(() => {
            this.credential = credential;
            this.loaded = true;
        });
    };
    //
    // assignAsGuest = async () => {
    //     runInAction(() => {
    //         this.assigningAsGuest = true;
    //     });
    //
    //     const credential = await this.entryApi.entryAsGuest();
    //     await this.credentialManager.save(credential);
    //
    //     runInAction(() => {
    //         this.credential = credential;
    //         this.loaded = true;
    //         this.assigningAsGuest = false;
    //     });
    // };
    //
    // assignWithFacebook = async (
    //     code: string,
    //     verifier: string
    // ) => {
    //     runInAction(() => {
    //         this.assigningWithFacebook = true;
    //     });
    //
    //     const credential = await this.entryApi.entryWithFacebook(code, verifier);
    //     await this.credentialManager.save(credential);
    //
    //     runInAction(() => {
    //         this.credential = credential;
    //         this.loaded = true;
    //         this.assigningWithFacebook = false;
    //     });
    // };

    delete = async () => {
        await this.credentialManager.delete();

        runInAction(() => {
            this.credential = null;
        });
    };



    // listenToCredentialSaved = async (
    //     credential: string
    // ) => {
    //     await this.save(credential)
    // }
}

decorate(injectable(), AppCredentialController);
decorate(inject(Dispatcher), AppCredentialController, 0);
decorate(inject(CredentialManager), AppCredentialController, 1);

export {AppCredentialController};
